import {useState} from 'react';
import PropTypes from 'prop-types';
import ExpandableListView from './ExpandableListView';

function ExpandableListContainer({items, initialNumberOfItems, buttonLabel}) {
  const [isExpanded, setIsExpanded] = useState(false);
  const itemsToShow = isExpanded ? [...items] : [...items].slice(0, initialNumberOfItems);
  const showButton = !isExpanded && initialNumberOfItems < items.length;

  return (
    <ExpandableListView
      items={itemsToShow}
      onExpand={() => setIsExpanded(true)}
      buttonLabel={buttonLabel}
      showButton={showButton}
    />
  );
}

ExpandableListContainer.propTypes = {
  items: PropTypes.array.isRequired,
  initialNumberOfItems: PropTypes.number.isRequired,
  buttonLabel: PropTypes.string.isRequired
};

export default ExpandableListContainer;
